import React, { useMemo } from 'react';
import { Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Select from '@shared/v2/components/Select';

const TravellingTo = ({ value, destinations, destinationNames, onSubmit }) => {
  const options = useMemo(
    () => [
      { text: 'All locations', value: null },
      ...destinations
        .filter((d) => !d.theme)
        .map((o) => ({ text: o.title, value: o.name }))
        .filter((v) => destinationNames && destinationNames.includes(v.value))
        .sort((a, b) => {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        }),
    ],
    [destinations, destinationNames],
  );

  return (
    <Flex justifyContent="center" alignItems="center" height="48px">
      <Select
        id="travelling-to"
        value={value || ''}
        options={options}
        disabled={destinations.length === 0}
        onSelectedChange={onSubmit}
        placeholder="Travelling to"
        prefix="To"
      />
    </Flex>
  );
};

TravellingTo.propTypes = {
  value: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  destinationNames: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TravellingTo;
